import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import clientService from "../../services/client/clientService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";


export default function ClientList() {

    const [client, setClient] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        loadClient();
    }, [page, search]);

    const loadClient = async () => {

        try {

            setLoading(true);

            const response = await clientService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setClient(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };
    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await clientService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadClient();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Client</h2>

                <Link
                    to="/clients/add"
                    className="btn btn-primary"
                >
                    Add Client
                </Link>

            </div>
            <div className="d-flex mb-3 gap-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search Client..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>
            </div>
            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>

                            <tr>
                                <th>Logo</th>
                                <th>Client Name</th>
                                <th>Website</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>

                        </thead>

                        <tbody>

                            {
                                loading ?

                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            Loading...
                                        </td>
                                    </tr>

                                    :

                                    client.length === 0 ?

                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                No Client Found
                                            </td>
                                        </tr>

                                        :

                                        client.map(item => (

                                            <tr key={item.clientId}>

                                                <td style={{ width: "90px" }}>

                                                    {
                                                        item.logo ?

                                                            <img
                                                                src={`${process.env.REACT_APP_SERVER_URL}${item.logo}`}
                                                                alt={item.clientName}
                                                                className="img-thumbnail"
                                                                style={{
                                                                    width: "70px",
                                                                    height: "70px",
                                                                    objectFit: "contain"
                                                                }}
                                                            />

                                                            :

                                                            "-"
                                                    }

                                                </td>

                                                <td>
                                                    {item.clientName}
                                                </td>

                                                <td>

                                                    {
                                                        item.website ?

                                                            <a
                                                                href={item.website}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {item.website}
                                                            </a>

                                                            :

                                                            "-"
                                                    }

                                                </td>

                                                <td>

                                                    {
                                                        item.isActive
                                                            ? <span className="badge bg-success">Active</span>
                                                            : <span className="badge bg-danger">Inactive</span>
                                                    }

                                                </td>

                                                <td>

                                                    <Link
                                                        to={`/clients/edit/${item.clientId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>

                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.clientId)}
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))
                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}